import {
  getCartIdPendingRemoval,
} from 'actions/CartActions';

import * as ActionTypes from 'actions/CartActions';
import root from 'window-or-global';

const initialCartItems = [];
const mapOffer = offer => {
  const sanitizedOffer = {
    ...offer,
    amount: Number(offer.amount),
    quantity: offer.quantity ? Number(offer.quantity) : 1,
    image: offer.image || `${root.STATIC_URL}assets/images/no-image.png`,
    isEditingQuantity: false,
    errors: [],
  };

  return {
    ...sanitizedOffer,
    undo: !!getCartIdPendingRemoval(sanitizedOffer),
  };
};

const cartItemsWithError = (errors, cart) => {
  const itemsWithError = Object.keys(errors);

  return cart.offers.map(item => {
    if (itemsWithError.indexOf(item.id) !== -1) {
      const errorKeys = Object.keys(errors[item.id]);
      return {
        ...mapOffer(item),
        errors: errorKeys.map(errorKey => errors[item.id][errorKey][0]),
      };
    }
    return mapOffer(item);
  });
};

const cartItems = (state = initialCartItems, action) => {
  switch (action.type) {
    case ActionTypes.HANDLE_FETCH_CART_SUCCESS:
    case ActionTypes.HANDLE_ADD_TO_CART_SUCCESS:
    case ActionTypes.HANDLE_REMOVE_ITEM_FROM_CART_SUCCESS:
    case ActionTypes.HANDLE_EDIT_CART_ITEM_QUANTITY_SUCCESS:
    case ActionTypes.HANDLE_SUBMIT_CART_SUCCESS:
    case ActionTypes.HANDLE_CLEAR_FAULTY_CART_SUCCESS:
      try {
        const { offers } = action.response.cart;
        return offers.map(mapOffer);
      } catch (e) {
        return initialCartItems;
      }

    case ActionTypes.HANDLE_REMOVE_ITEM_FROM_CART_REQUEST:
    case ActionTypes.HANDLE_UNDO_REMOVE_ITEM_FROM_CART:
      const { id } = action.payload;
      return state.map(item => {
        if (item.id !== id) {
          return item;
        }
        return {
          ...item,
          undo: !item.undo,
        };
      });

    case ActionTypes.HANDLE_EDIT_CART_ITEM_QUANTITY_REQUEST: {
      const { id } = action;
      return state.map(item => {
        if (item.id !== id) {
          return item;
        }
        return {
          ...item,
          isEditingQuantity: true,
        };
      });
    }

    case ActionTypes.HANDLE_REMOVE_ITEM_FROM_CART_FAILURE:
    case ActionTypes.HANDLE_EDIT_CART_ITEM_QUANTITY_FAILURE: {
      const { id, errors: { errors, cart: { offers } } } = action;
      return offers.map(item => {
        if (item.id !== id) {
          return mapOffer(item);
        }
        return {
          ...mapOffer(item),
          errors,
        };
      });
    }

    case ActionTypes.HANDLE_CHECKOUT_CART_FAILURE: {
      const { errors: { errors, cart, isCartInvalid } } = action;
      if (!isCartInvalid) {
        return state;
      }

      if (!cart) {
        return initialCartItems;
      }

      // is moving to cart tab from shipping tab,
      // then update the cart with updated response
      return cartItemsWithError(errors, cart);
    }

    case ActionTypes.HANDLE_SUBMIT_CART_FAILURE: {
      const { errors: { errors, cart } } = action;
      if (!cart) {
        return initialCartItems;
      }

      return cartItemsWithError(errors, cart);
    }

    case ActionTypes.HANDLE_SUBMIT_CART_REQUEST: {
      // Visually hide all items that are pending removal
      return state.filter(item => !item.undo);
    }

    default:
      return state;
  }
};

export default cartItems;

export const getCartItems = state => state;



// WEBPACK FOOTER //
// ./src/cart/reducers/items/index.js